import script from "./AboutGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutGrid.vue?vue&type=script&setup=true&lang=js"

import "./AboutGrid.vue?vue&type=style&index=0&id=5adf3be2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adf3be2"]])

export default __exports__